const palette = {
  white: '#ffffff',
  black: '#000000',
  basis1: '#151925',
  basis2: '#1D2334',
  basis3: '#3c3f48',
  basis4: '#a3a6a7',
  basis5: '#b8bfc2',
  basis6: '#eaeaec',
  green: '#01ca6e',
  blue: '#00abd9',
  orange: '#e27301',
  red: '#e20101',
  yellow: '#FFE051',
  onesportBlue: '#1cc4e8',
  onesportGreen: '#1ce8b5'
};

module.exports = {
  theme: {
    backgroundImage: '/images/background.jpg',
    color: {
      white: palette.white,
      background: palette.basis1,
      basis1: palette.basis1,
      basis2: palette.basis2,
      basis3: palette.basis3,
      basis4: palette.basis4,
      basis5: palette.basis5,
      basis6: palette.basis6,
      darkBackground: palette.basis1,
      disabled: palette.basis4,
      invertableBlack: palette.black,
      invertableWhite: palette.white,
      invertableBasis1: palette.basis1,
      invertableBasis2: palette.basis2,
      invertableBasis3: palette.basis3,
      invertableBasis4: palette.basis4,
      invertableBasis5: palette.basis5,
      invertableBasis6: palette.basis6,
      widgetPrimary: palette.onesportBlue,
      widgetSecondary: palette.onesportGreen,
      primary: palette.green,
      secondary: palette.basis2,
      info: palette.blue,
      warning: palette.orange,
      danger: palette.red,
      panel: palette.basis1, // bg color
      panelAccent: palette.basis5, // text color
      panelSecondary: palette.basis3,
      panelSelected: palette.white,
      success: palette.green,
      orange: palette.orange,
      green: palette.green,
      red: palette.red,
      blue: palette.blue,
      yellow: palette.yellow,
      enterButton: palette.green,
      enteredButton: palette.blue,
      sportsIcon: palette.black
    }
  },
  skin: {
    Tab: {
      activeBackgroundColor: palette.basis3
    }
  }
};
